export default __webpack_public_path__ + "static/media/Source code-amico.f50d0ef7.svg";